export default "__VITE_ASSET__BWiMeYNK__"